import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-textile-model-category5s',
  templateUrl: './textile-model-category5s.component.html',
  styleUrls: ['./textile-model-category5s.component.css']
})
export class TextileModelCategory5sComponent implements OnInit {
    public itemsListCategories5: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {

    }

    private async loadTextileModelCategory5s(): Promise<void> {
        this.itemsListCategories5 = await this.datatask.Post(2686);
    }

    public goToFunc(state: any) {
        switch (state) {
            case 'textilemodelcategory5':
                this.stateService?.go('textilemodelcategory5', { textilemodelcategory5_keyno: '0' });
                break;
            default:
                break;
        }
    }

    private async init() {
        this.loadTextileModelCategory5s();
    }

    ngOnInit() {
        this.init();
    }
}



//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('textileModelCategory5s', {
//        templateUrl: 'views/components/views/textileModelCategory5s/textileModelCategory5s.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'textileModelCategory5sService', function (stateService, textileModelCategory5sService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            vm.model = {
//                itemsListCategories5: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadTextileModelCategory5s() {
//                vm.model.itemsListCategories5 = await textileModelCategory5sService.listTextileModelCategory5s();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'textilemodelcategory5':
//                        go({ textilemodelcategory5_keyno: '0' });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadTextileModelCategory5s();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
